<template>
  <li class="nav-item">
    <a class="nav-link sidebar-collapse-title" @click="toggleShow()">
      <slot>
        <div class="d-flex">
          <i v-if="icon" :class="icon"></i>
          <p>{{ name }}</p>
          <i :class="collapseIcon" class="dropdownIcon"></i>
        </div>
      </slot>
    </a>
    <!--    <collapse-transition group>-->
    <div v-show="show" class="link-container" :key="name">
      <slot name="sublinks"></slot>
    </div>
    <!--    </collapse-transition>-->
  </li>
</template>
<script>
// import { CollapseTransition } from "vue2-transitions";

export default {
  name: "sidebar-colapse",
  data() {
    return {
      show: false,
      collapseIcon: "fas fa-chevron-down"
    };
  },
  // components: {
  //   CollapseTransition
  // },
  props: {
    name: String,
    icon: String,
    tag: {
      type: String,
      default: "router-link"
    }
  },
  methods: {
    toggleShow: function() {
      this.show = !this.show;
      this.collapseIcon = this.show
        ? "fas fa-chevron-up"
        : "fas fa-chevron-down";
    }
  }
};
</script>
<style scoped>
.link-container {
  margin-left: 25px;
  position: relative !important;
}

.sidebar-collapse-title {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.dropdownIcon {
  font-size: 1.3em !important;
}
</style>
